import React from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import { TenantStatus } from '@debbie/common/dist/tenants/index.js';
import { selectTenant } from '@debbie/cortex/dist/tenant/selectors.js';
import THEME from '../../../theme.js';
import Globe from '../../Icons/Globe.js';
import User from '../../Icons/User.js';
const UserInfo = (props) => {
    const lang = useSelector((s) => s.lang);
    const tenant = useSelector(selectTenant);
    const companyRelations = tenant?.status === TenantStatus.Demo
        ? props.companyRelations && props.companyRelations.length > 0
            ? props.companyRelations
            : getDemoRelatedCompanies()
        : props.companyRelations;
    if (!companyRelations)
        return null;
    return (React.createElement("div", null, companyRelations
        .filter((cR) => {
        const hasAddress = cR.address && cR.address.address && cR.address.address !== 'null';
        const hasName = !!cR.name;
        const hasCountry = cR.address && cR.address.country;
        const hasCompanyRelations = !!cR.relationReasons.length;
        return hasAddress || hasName || hasCountry || hasCompanyRelations;
    })
        .map((cR) => {
        return (React.createElement(CompanyRelationStyled, null,
            React.createElement("h2", null,
                cR.name,
                ' ',
                React.createElement("span", null, cR ? (cR.type !== 'PERSON' ? (React.createElement("span", null,
                    React.createElement(Globe, null),
                    " ",
                    lang.debtorInfo.company)) : (React.createElement("span", null,
                    React.createElement(User, null),
                    " ",
                    lang.debtorInfo.private))) : null)),
            React.createElement("div", { className: "company-relation-address" },
                cR.address &&
                    cR.address.address &&
                    cR.address.address !== 'null' && (React.createElement(React.Fragment, null,
                    cR.address.address,
                    cR.address.coAddress && `, c/o ${cR.address.coAddress}`,
                    ",",
                    React.createElement("br", null),
                    cR.address.zipcode,
                    " ",
                    cR.address.city)),
                cR.address && cR.address.country && (React.createElement("p", null, cR.address.country))),
            React.createElement("p", null, cR.relationReasons && !!cR.relationReasons.length && (React.createElement("div", { className: "relation-roles" },
                React.createElement("h3", null, lang.debtorInfo.roles),
                cR.relationReasons
                    .map((rR) => {
                    if (roleFinder(rR, 'LEDELSESORGAN', 'FUNKTION', 'DIREKTØR')) {
                        return React.createElement(Tag, null, lang.debtorInfo.director);
                    }
                    else if (roleFinder(rR, 'LEDELSESORGAN', 'FUNKTION', 'DIREKTION')) {
                        return React.createElement(Tag, null, lang.debtorInfo.executiveBoard);
                    }
                    else if (roleFinder(rR, 'REGISTER', 'FUNKTION', 'Reel ejer')) {
                        return React.createElement(Tag, null, lang.debtorInfo.beneficialOwner);
                    }
                    else if (roleFinder(rR, 'STIFTERE', 'FUNKTION', 'STIFTERE')) {
                        return React.createElement(Tag, null, lang.debtorInfo.founder);
                    }
                    else if (roleFinder(rR, 'REGISTER', 'EJERANDEL_PROCENT')) {
                        return (React.createElement(Tag, null,
                            lang.debtorInfo.owner,
                            ": ",
                            rR.value));
                    }
                    else if (roleFinder(rR, 'FULDT_ANSVARLIG_DELTAGERE', 'FUNKTION', 'INTERESSENTER')) {
                        return React.createElement(Tag, null, lang.debtorInfo.stakeholder);
                    }
                    else if (roleFinder(rR, 'LEDELSESORGAN', 'FUNKTION', 'FORMAND')) {
                        return React.createElement(Tag, null, lang.debtorInfo.chairperson);
                    }
                    else if (roleFinder(rR, 'LEDELSESORGAN', 'FUNKTION', 'ADM. DIR.')) {
                        return React.createElement(Tag, null, lang.debtorInfo.managingDirector);
                    }
                    else if (roleFinder(rR, 'LEDELSESORGAN', 'FUNKTION', 'BESTYRELSESMEDLEM')) {
                        return React.createElement(Tag, null, lang.debtorInfo.boardMember);
                    }
                    else if (roleFinder(rR, 'REGISTER', 'EJERANDEL_KAPITALKLASSE')) {
                        return (React.createElement(Tag, null,
                            lang.debtorInfo.equityTier,
                            ": ",
                            rR.value));
                    }
                    else if (roleFinder(rR, 'LEDELSESORGAN', 'FUNKTION', 'NÆSTFORMAND')) {
                        return React.createElement(Tag, null, lang.debtorInfo.viceChairperson);
                    }
                    else if (roleFinder(rR, 'REGISTER', 'EJERANDEL_STEMMERET_PROCENT')) {
                        return (React.createElement(Tag, null,
                            lang.debtorInfo.rightToVote,
                            ": ",
                            rR.value));
                    }
                    else if (roleFinder(rR, 'REGISTER', 'EJERANDEL_STEMMERET_PROCENT')) {
                        return (React.createElement(Tag, null,
                            lang.debtorInfo.rightToVote,
                            ": ",
                            rR.value));
                    }
                    else if (roleFinder(rR, 'REVISION', 'FUNKTION', 'REVISION')) {
                        return React.createElement(Tag, null, lang.debtorInfo.audit);
                    }
                    else if (roleFinder(rR, 'REGISTER', 'SÆRLIGE_EJERFORHOLD')) {
                        return React.createElement(Tag, null, lang.debtorInfo.specialOwnership);
                    }
                    else if (roleFinder(rR, 'REGISTER', 'EJERANDEL_MEDDELELSE_DATO') ||
                        roleFinder(rR, 'REGISTER', 'EJERANDEL_DOKUMENT_ID')) {
                        return;
                    }
                    else {
                        return (React.createElement(Tag, { light: true },
                            rR.type,
                            ": ",
                            rR.value));
                    }
                })
                    .filter((x) => !!x))))));
    })));
};
const roleFinder = (rR, maintype, type, value) => rR.maintype === maintype &&
    rR.type === type &&
    (value === undefined || rR.value === value);
export default UserInfo;
export const Tag = styled.div `
  display: inline-block;
  margin: 0 5px 3px 0;
  padding: 0.2em 0.6em;
  border-radius: 2px;
  font-weight: bold;
  font-size: 0.6em;
  background-color: ${(props) => props.light ? 'lightgrey' : THEME.COLOR_PRIMARY};
  color: ${(props) => (props.light ? 'initial' : THEME.COLOR_SECONDARY)};
`;
export const CompanyRelationStyled = styled.div `
  background-color: #ececec;
  border-radius: 2px;
  padding: 1px 20px;
  margin-bottom: ${THEME.GRID_SPACING}px;

  h2 {
    font-size: 1em;

    span {
      float: right;
      font-weight: normal;
      font-size: 0.8em;
    }
  }

  .company-relation-address {
    font-size: 0.8em;
  }

  .relation-roles {
    h3 {
      text-transform: uppercase;
      opacity: 0.6;
      font-size: 0.8em;
      margin-bottom: 0.3em;
    }
  }
`;
const getDemoRelatedCompanies = () => [
    {
        name: 'Peter Petersen',
        type: 'PERSON',
        address: {
            city: 'København',
            address: 'Demovej 1',
            country: 'DK',
            zipcode: '1000',
            coAddress: null,
        },
        enhedsnummer: 4000471683,
        relationReasons: [
            {
                to: null,
                from: '2015-05-01T00:00:00+00:00',
                type: 'FUNKTION',
                value: 'ADM. DIR.',
                maintype: 'LEDELSESORGAN',
            },
            {
                to: null,
                from: '2015-05-01T00:00:00+00:00',
                type: 'EJERANDEL_PROCENT',
                value: '0.52',
                maintype: 'REGISTER',
            },
            {
                to: null,
                from: '2015-05-01T00:00:00+00:00',
                type: 'EJERANDEL_STEMMERET_PROCENT',
                value: '0.52',
                maintype: 'REGISTER',
            },
            {
                to: null,
                from: '2015-05-01T00:00:00+00:00',
                type: 'FUNKTION',
                value: 'Reel ejer',
                maintype: 'REGISTER',
            },
            {
                to: null,
                from: '2015-05-01T00:00:00+00:00',
                type: 'SÆRLIGE_EJERFORHOLD',
                value: 'Har indirekte besiddelser',
                maintype: 'REGISTER',
            },
        ],
    },
    {
        name: 'Testperson',
        type: 'PERSON',
        address: {
            city: 'København',
            address: 'Demovej 1',
            country: 'DK',
            zipcode: '1000',
            coAddress: null,
        },
        enhedsnummer: 4000757543,
        relationReasons: [
            {
                to: null,
                from: '2015-05-01T00:00:00+00:00',
                type: 'FUNKTION',
                value: 'DIREKTØR',
                maintype: 'LEDELSESORGAN',
            },
            {
                to: null,
                from: '2015-05-01T00:00:00+00:00',
                type: 'EJERANDEL_PROCENT',
                value: '0.48',
                maintype: 'REGISTER',
            },
            {
                to: null,
                from: '2015-05-01T00:00:00+00:00',
                type: 'EJERANDEL_STEMMERET_PROCENT',
                value: '0.48',
                maintype: 'REGISTER',
            },
            {
                to: null,
                from: '2015-05-01T00:00:00+00:00',
                type: 'FUNKTION',
                value: 'Reel ejer',
                maintype: 'REGISTER',
            },
            {
                to: null,
                from: '2015-05-01T00:00:00+00:00',
                type: 'SÆRLIGE_EJERFORHOLD',
                value: 'Har indirekte besiddelser',
                maintype: 'REGISTER',
            },
        ],
    },
    {
        name: 'TEST HOLDING ApS',
        type: 'VIRKSOMHED',
        address: {
            city: 'København',
            address: 'Demovej 1',
            country: 'DK',
            zipcode: '1000',
            coAddress: '',
        },
        enhedsnummer: 4000569733,
        relationReasons: [
            {
                to: null,
                from: '2015-05-01T00:00:00+00:00',
                type: 'FUNKTION',
                value: 'STIFTERE',
                maintype: 'STIFTERE',
            },
            {
                to: null,
                from: '2015-05-01T00:00:00+00:00',
                type: 'EJERANDEL_MEDDELELSE_DATO',
                value: '2015-05-12',
                maintype: 'REGISTER',
            },
            {
                to: null,
                from: '2015-05-01T00:00:00+00:00',
                type: 'EJERANDEL_PROCENT',
                value: '0.5',
                maintype: 'REGISTER',
            },
            {
                to: null,
                from: '2015-05-01T00:00:00+00:00',
                type: 'EJERANDEL_STEMMERET_PROCENT',
                value: '0.5',
                maintype: 'REGISTER',
            },
        ],
    },
];
//# sourceMappingURL=UserCompanyRelations.js.map